import { createMachine, assign, EventObject } from 'xstate';
import Cookies from 'js-cookie';
import { lgcProductRecommender } from '@/constants/cookies';
import { submitAllAnswers, getAllQuestions } from './services';
import { generalHealth } from './general-health';
import {
  ProductRecommenderContext,
  ProductRecommenderStateSchema,
  ProductRecommenderStates,
  QuestionnaireMachineEvent,
  MachineId,
  QuestionnaireEvent,
  QuestionnaireResponse,
  RecommendationsData,
} from './types';

export const productRecommender = createMachine<ProductRecommenderContext, EventObject, ProductRecommenderStateSchema>(
  {
    id: MachineId.productRecommender,
    initial: ProductRecommenderStates.loadingQuestions,
    context: {
      questions: [],
      answers: {},
    },
    states: {
      [ProductRecommenderStates.loadingQuestions]: {
        invoke: {
          id: MachineId.getQuestions,
          src: 'getAllQuestions',
          onDone: {
            target: ProductRecommenderStates.questionsLoaded,
            actions: assign<ProductRecommenderContext, EventObject & QuestionnaireResponse>(
              (_, { data: { firstQuestionId, questions } }) => ({
                questions,
                firstQuestionId,
              }),
            ),
          },
          onError: {
            target: 'done',
          },
        },
      },
      [ProductRecommenderStates.questionsLoaded]: {
        invoke: {
          id: MachineId.generalHealth,
          src: 'generalHealth',
          data: ({ firstQuestionId, questions }) => ({
            ...generalHealth.context,
            questions,
            currentQuestion: questions.find(question => question.id === firstQuestionId),
          }),
          onDone: {
            target: ProductRecommenderStates.submitQuestionnaire,
            actions: assign<ProductRecommenderContext, EventObject & QuestionnaireMachineEvent>({
              answers: (_, event) => event.data,
            }),
          },
        },
      },
      [ProductRecommenderStates.submitQuestionnaire]: {
        invoke: {
          id: MachineId.submitQuestionnaire,
          src: 'submitAllAnswers',
          onDone: {
            target: ProductRecommenderStates.done,
            actions: (_, { data }: { data: RecommendationsData }) => {
              Cookies.set(lgcProductRecommender, { ...data, products: data?.products?.slice(0, 6) });
            },
          },
          onError: {
            target: ProductRecommenderStates.failed,
          },
        },
      },
      [ProductRecommenderStates.failed]: {
        on: {
          [QuestionnaireEvent.RETRY]: { target: ProductRecommenderStates.submitQuestionnaire },
        },
      },
      [ProductRecommenderStates.done]: {
        type: 'final',
      },
    },
  },
  {
    services: {
      getAllQuestions: () => getAllQuestions(),
      submitAllAnswers: (context: ProductRecommenderContext) => submitAllAnswers(context.answers),
      generalHealth,
    },
  },
);
